import React, { HTMLInputTypeAttribute } from 'react'

export const HiddenInput = React.forwardRef<
  HTMLInputElement,
  {
    value: string | number | readonly string[] | undefined
    name: string | undefined
    form: string | undefined
    isRequired?: boolean
    min?: number
    max?: number
    type?: HTMLInputTypeAttribute
  }
>(({ value, name, form, isRequired, type, min, max }, ref) => {
  return (
    <input
      style={{
        border: 0,
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        width: '1px',
        whiteSpace: 'nowrap'
      }}
      aria-required={isRequired}
      required={isRequired}
      tabIndex={-1}
      aria-hidden="true"
      value={value}
      onChange={() => {}}
      ref={ref}
      name={name}
      form={form}
      type={type ?? 'text'}
      min={min}
      max={max}
    />
  )
})
HiddenInput.displayName = 'HiddenInput'
